module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/388a295a1ca324fb12e819fc81a905f1.png";